/**
 * Add subscribe/unsubscribe to the NicheListWidget.
 */

import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { showAuthModal } from "store/application/application-action";
import { useMyNichesQuery } from "queries";
import { INiche } from "services/types";
import { apiNiches } from "services";
import { useVisitorInfo } from "hooks";

import { INicheInfo, NicheListWidget } from "./NicheListWidget";

export const NicheListWidgetAlive = (props: {
  title: string;
  link: string;
  className?: string;
  niches: INicheInfo[];
  page: number;
}): JSX.Element => {
  const [following, setFollowing] = useState<string[]>([]);
  const [niches, setNiches] = useState<INicheInfo[]>(props.niches);
  const [isFollowButtonClicked, setIsFollowButtonClicked] = useState(false);

  const dispatch = useDispatch();

  const query = useMyNichesQuery({
    previews: false,
  });

  const me = useVisitorInfo();

  useEffect(() => {
    if (query.status === "success" && query.data) {
      const ids = query.data.niches.map((niche: INiche): string => niche.id);
      setFollowing(ids);
    }
  }, [query.status, query.data]);

  useEffect(() => {
    if (isFollowButtonClicked) {
      setNiches((prev) => prev.map((n: INicheInfo): INicheInfo => ({
        ...n,
        following: following.indexOf(n.id) >= 0,
      })));
    }
  }, [props.niches, following, isFollowButtonClicked]);

  useEffect(() => {
    const newNiches: INicheInfo[] = [];
    props.niches.forEach((el: INicheInfo) => {
      if (!following.find(id => id === el.id)) {
        newNiches.push({
          id: el.id,
          name: el.name,
          image: el.image,
          subscribers: el.subscribers,
          following: following.indexOf(el.id) >= 0
        });
      }
    });
    setNiches(newNiches);
    // eslint-disable-next-line
  }, [props.niches]);

  const onFollow = async (id: string, follow: boolean) => {
    if (me === null) {
      dispatch(showAuthModal());
    } else if (follow) {
      setIsFollowButtonClicked(true);
      setFollowing(prev => ([...prev, id]));
      await apiNiches.follow(id);
    } else {
      setIsFollowButtonClicked(true);
      setFollowing(prev => prev.filter((x) => x !== id));
      await apiNiches.unfollow(id);
    }
  };

  return (
    <NicheListWidget
      title={props.title}
      link={props.link}
      className={props.className}
      niches={niches}
      onFollow={onFollow}
      page={props.page}
    />
  );
};
